import { AnyObject } from "@/types/BaseTypes";

export function roundTo2(number: number) {
  return Math.round(number * 100) / 100;
}

/**
 * Add fields from first param object to second param object
 * @param from {Object} the object from which the fields will be taken
 * @param to {Object} the object to which the fields will be added
 * @returns {boolean} execution status
 */
export function assignObject(from: unknown, to: unknown) {
  const fromB = getNotNullObject(from);
  const toB = getNotNullObject(to);

  if (fromB && toB) {
    Object.assign(toB, fromB);
    return true;
  }
  return false;
}

export const isNotNullObject = (obj: unknown): boolean => {
  return typeof obj === "object" && obj !== null;
};

export function getNotNullObject(object: unknown): NonNullable<object> | false {
  if (typeof object === "object" && object !== null && !Array.isArray(object)) {
    return object;
  }
  return false;
}

/**
 * создаёт случайную строку из символов
 * @param length длина строки
 * @param characters символы для генерации (по умолчанию английский алфавит и цифры)
 */
export function randomString(
  length = 8,
  characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
) {
  let result = "";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function makeObjectFromKeyArray(keys: string[]) {
  return keys.reduce((obj: NonNullable<object>, key) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    obj[key] = null;
    return obj;
  }, {});
}

/**
 * Копирует содержимое полей на целевой объект
 * если на целевом объекте имеются такие поля
 * @param from - исходный объект
 * @param to - целевой объект
 */
export function enhanceObjectCopy(
  from: Record<string, unknown>,
  to: Record<string, unknown>
): void {
  Object.keys(to).forEach((key) => {
    if (key in from) to[key] = from[key];
  });
}

/**
 * Определяет является ли объект датой
 * @return boolean
 * @param date - искомый объект
 */
export function isDate(date: unknown) {
  return date instanceof Date;
}
